import React from 'react';
import { TrendingUp, Users, Shield, BarChart3 } from 'lucide-react';
import capabiliaLogo from '../../assets/capabilia-logo.png';
import { CONTACT_MAILTO, HERO_GRADIENT } from './landingConstants';

const logoStyleWhite = {
  filter: 'brightness(0) invert(1)'
};

// Mismas 4 tarjetas que ya existen en el panel del login (LoginPage.jsx) - se reutilizan tal cual
const FEATURES = [
  { icon: TrendingUp, title: 'Evolución del Riesgo', desc: 'Seguimiento en tiempo real' },
  { icon: Users, title: 'Vista 360°', desc: 'Perfil completo del alumno' },
  { icon: Shield, title: 'Multi-Partner', desc: 'Gestión centralizada' },
  { icon: BarChart3, title: 'Analytics', desc: 'Métricas y KPIs' }
];

export const LandingHero = () => (
  <section className="relative overflow-hidden" style={{ background: HERO_GRADIENT }} data-testid="landing-hero">
    <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, white 1px, transparent 1px)', backgroundSize: '32px 32px' }} />
    <div className="relative max-w-7xl mx-auto px-6 py-20 md:py-28">
      <div className="flex items-center gap-3 mb-10">
        <img src={capabiliaLogo} alt="Capabilia" style={{ width: 40, height: 40, ...logoStyleWhite }} />
        <div>
          <p className="font-manrope font-bold text-white text-lg leading-none">Persistencia 360</p>
          <p className="text-white/70 text-xs">by Capabilia</p>
        </div>
      </div>

      <div className="max-w-2xl">
        <h1 className="font-manrope text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6">
          Transforma datos en decisiones
        </h1>
        <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-10">
          Detectá el riesgo de abandono estudiantil a tiempo, activá acciones de retención y medí el impacto real con datos, no con corazonadas.
        </p>
        <div className="flex flex-wrap items-center gap-4">
          <a
            href={CONTACT_MAILTO}
            className="font-semibold px-6 py-3 rounded-full bg-white text-emerald-800 hover:bg-white/90 transition-colors"
            data-testid="landing-hero-cta-contact"
          >
            Contactanos
          </a>
          <a
            href="#como-funciona"
            className="font-semibold px-6 py-3 rounded-full border border-white/40 text-white hover:bg-white/10 transition-colors"
            data-testid="landing-hero-cta-how"
          >
            Cómo funciona
          </a>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-16 max-w-3xl">
        {FEATURES.map((feature, idx) => (
          <div
            key={idx}
            className="flex flex-col gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4 hover:bg-white/15 transition-colors"
            data-testid={`landing-hero-card-${idx}`}
          >
            <div className="p-2 bg-white/20 rounded-lg w-fit">
              <feature.icon className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="font-semibold text-sm text-white">{feature.title}</p>
              <p className="text-white/70 text-xs">{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
